import React, { useEffect, useState } from "react";
import Dialog from "../../../GenericComponents/dialog";
import { FoundationsInput } from "../../../GenericComponents/input";
import FoundationsSelect from "../../../GenericComponents/select";
import { FoundationsTextArea } from "../../../GenericComponents/textarea";
import { useEditDashboardMutation } from "../../../Redux/Workspace/workspaceActionsSlice";
import { deleteWorkspaceActions, setWorkspaceActions, updateWorkspaceActions, WorkspaceActions } from "../../../Redux/Workspace/workspaceActionReducers";
import { useDispatch, useSelector } from "react-redux";
import { PayloadAction } from "@reduxjs/toolkit";
import { AppState, getCurrentUserData, RootState } from "../../../Redux/store";
import { FoundationsGenericToaster } from "../../../GenericComponents/FoundationsGenericToaster";
import { WorkspaceApiDTO_Workspace } from "../../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace";
import { FoundationsConstants } from "../../../FoundationsConstants";
import { FoundationsEnums } from "../../../Enums/FoundationsEnums";
import { class_WorkspaceApiDTO_Workspace, useWorkspaceStore } from "../../Workspace/workspaceContext";

// TO DO: NEED TO UPDATE THE CODE TO HANDLE INSTANT REFLECTION OF WS CHANGES CURRENT CODE IS BAD -- HARSH (IK I HAVE WRITTEN THAT)

interface EditWorkspaceDialogProps {
    isOpen: boolean;
    onClose: () => void;
    DialogMsg?: string;
    DialogState?: any;
}


declare let window: any

const EditWorkspaceDialog: React.FC<EditWorkspaceDialogProps> = ({ isOpen, onClose, DialogState }) => {

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);

    const workspaceActions = useSelector((state: AppState) =>  // This is to fetch updated data(for instant reflection) without refreshing of page, this maintains app state and fetch data. TODO HARSH: Create or make use of same, for hometiles. 
        state.WorkspaceActions.workspace_Actions_State.find(
            (item: any) => item.workspaceId === currentWorkspaceData?.WorkspaceId
        )
    )
    const [workspaceName, setWorkspaceName] = useState(workspaceActions?.Name || currentWorkspaceData?.Name || ''); //When for first time we launch edit workspace dialog we are setting values in props through worksapce object.And when we update the workspace we are setting values in workspaceActions object, through reducer. Thus while launching the dialog we are checking if workspaceActions object is present or not, if not then we are setting values from workspace object. "This needs better implementation".
    const [workspaceDesr, setWorkspaceDesr] = useState(workspaceActions?.Description || currentWorkspaceData?.Description || '');
    const [workspaceAccessLevel, setWorkspaceAccessLevel] = useState(currentWorkspaceData?.PrivacyLock || workspaceActions?.PrivacyLock);
    const [isLoading, setIsLoading] = useState(false);
    const [editDashboard] = useEditDashboardMutation();
    const dispatch = useDispatch()
    const setupWorkspace = useWorkspaceStore((s) => s.setupWorkspace);


    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setWorkspaceAccessLevel(parseInt(event.target.value));
    };
    useEffect(() => {
        if (currentWorkspaceData) {
            setWorkspaceName(workspaceActions?.Name || currentWorkspaceData?.Name || '');
            setWorkspaceDesr(workspaceActions?.Description || currentWorkspaceData?.Description || '');
            setWorkspaceAccessLevel(workspaceActions?.PrivacyLock || currentWorkspaceData?.PrivacyLock);
        }
    }, [currentWorkspaceData, workspaceActions, isOpen]);

    const updateWorkspaceName = useWorkspaceStore((s) => s.updateName);
    const updateWorkspaceDescription = useWorkspaceStore((s) => s.updateDescription);
    const updateWorkspacePrivacyLock = useWorkspaceStore((s) => s.updatePrivacyLock);

    useEffect(() => {
        if (!isOpen) {
            setIsLoading(false) // FP-11707 : Doing this to prevent fast multiple persistent clicks on save button
        }
    }, [isOpen]);


    const handleEditWorkspaceSave = () => {
        setIsLoading(true);
        const requestUserInfo = {
            WorkspaceId: currentWorkspaceData?.WorkspaceId || -1,
            Name: workspaceName.trim(),
            Description: workspaceDesr,
            PrivacyLock: workspaceAccessLevel,
            rgborname_color: currentWorkspaceData?.rgborname_color,
        }


        if (requestUserInfo.Name.trim() === "") {
            FoundationsGenericToaster('error', 'Workspace name cannot be empty.')
            return;
        }

        editDashboard(requestUserInfo)
            .unwrap()
            .then((response) => {
                if (response) {
                    const resultData = response.data;
                    if (resultData?.MessageResults?.length > 0) {
                        const successMessages = resultData.MessageResults.filter(
                            (messageResult: { HelpMessage: any; }) =>
                                messageResult.HelpMessage === FoundationsEnums.Status.Success
                        );
                        if (successMessages.length > 0) {
                            DialogState(false);
                            dispatch(deleteWorkspaceActions(currentWorkspaceData?.WorkspaceId))

                            try {
                                updateWorkspaceName(workspaceName)
                                updateWorkspaceDescription(workspaceDesr)
                                updateWorkspacePrivacyLock(Number(workspaceAccessLevel))
                            } catch (error) {
                                console.error(error)
                            }
                            //updateWorkspacePrivacyLock(workspaceAccessLevel) TODO: 11694 - Set privacy lock.

                            // editCallback({                 // This callback is to update data inside workspace. TODO HARSH : Create callback method for hometiles.- 
                            //     ...workspace,
                            //     WorkspaceId: WorkspaceId,
                            //     Name: workspaceName,
                            //     Description: workspaceDesr,
                            //     PrivacyLock: workspaceAccessLevel,
                            //     Privacy:workspaceAccessLevel
                            // })

                            const updatePayload: PayloadAction<{
                                workspaceId: number;
                                updates: Partial<WorkspaceActions>;
                            }> = {
                                payload: {
                                    workspaceId: currentWorkspaceData?.WorkspaceId,
                                    updates: {
                                        Name: workspaceName,
                                        Description: workspaceDesr,
                                        PrivacyLock: workspaceAccessLevel,
                                    },
                                },
                                type: 'updateWorkspaceActions',
                            };

                            dispatch(updateWorkspaceActions(updatePayload.payload));  // FP-10780 Updated the deleteWorkspaceActions call with updateWorkspaceActions

                            // updateDOMElements(WorkspaceId, workspaceName, workspaceDesr, workspaceAccessLevel);

                            FoundationsGenericToaster('success', successMessages[0].Message);

                        }
                        else {
                            DialogState(true);   // FP-10780 Pop up remains open
                            if (resultData.status === "Operation Not Allowed") {
                                FoundationsGenericToaster('error', "Sorry, you are not allowed to do this operation.")
                            } else {
                                FoundationsGenericToaster('error', resultData.MessageResults[0].Message);
                            }
                        }
                    } else {
                        FoundationsGenericToaster('error', "Something went wrong");
                    }
                }
            })
            .catch((error) => {
                DialogState(false)
                setIsLoading(false);
                window.healthLevelGlobal.handleAjaxPopupError(error);
                FoundationsGenericToaster('error', FoundationsConstants.toastrMessage.workspaceupdationfailure);
            });
    }

    return (
        <Dialog
            isOpen={isOpen}
            onClose={() => onClose()}
            title="Edit Workspace"
            className="left-align-text"
            buttons={[
                {
                    label: "Cancel",
                    id: "cancelEditWorkspace",
                    onClick: onClose,
                    className: "ui-button ui-corner-all ui-widget app-button negative",
                },
                {
                    label: "Save Changes",
                    id: "saveEditWorkspace",
                    onClick: handleEditWorkspaceSave,
                    className: "ui-button ui-corner-all ui-widget app-button",
                    disabled: isLoading
                },
            ]}
        >
            <div className="container">
                <table className="input-form-table-popup-window">
                    <tbody>
                        <tr>
                            <td
                                className="left"
                                style={{ width: '25%' }}
                            >
                                <div>Name:</div>
                            </td>
                            <td className="right">
                                <FoundationsInput
                                    id="text_edit_dashboard_name"
                                    value={workspaceName}
                                    onInput={(e: {
                                        target: { value: string }
                                    }) => {
                                        setWorkspaceName(
                                            e.target?.value
                                        )
                                    }}
                                    disabled={!!currentWorkspaceData?.AppGUID}
                                    containerClasses="field-add-new-dashboard"
                                    maxLength={50}
                                />
                                <div
                                    id="valmsg_text_edit_dashboard_name"
                                    className="field-validation-error"
                                    style={{ display: 'none' }}
                                ></div>
                            </td>
                        </tr>

                        <tr>
                            <td className="left">
                                <div>Description:</div>
                            </td>
                            <td className="right">
                                <FoundationsTextArea
                                    id="text_edit_dashboard_description"
                                    value={workspaceDesr}
                                    classes="field-add-new-dashboard"
                                    onInput={(e: {
                                        target: { value: string }
                                    }) => {
                                        setWorkspaceDesr(
                                            e.target?.value
                                        )
                                    }}
                                    disabled={!!currentWorkspaceData?.AppGUID}
                                    rows={6}
                                    cols={37}
                                />
                                <div
                                    id="valmsg_text_edit_dashboard_description"
                                    className="field-validation-error"
                                    style={{ display: 'none' }}
                                ></div>
                            </td>
                        </tr>

                        <tr>
                            <td className="left">
                                <div>Access Level:</div>
                            </td>
                            <td className="right">
                                <FoundationsSelect
                                    id="list_dashboard_privacy_lock"
                                    value={workspaceAccessLevel}
                                    onChange={handleChange}
                                    classes="field-auto-refresh w-100"
                                    customStyles={{ width: '100%', border: '1px solid #767676' }}
                                >
                                    <option value={0} selected={workspaceAccessLevel == 0} >Open, changes allowed</option>
                                    <option value={1} selected={workspaceAccessLevel == 1} >Shared lock, restricted updates</option>
                                    <option value={2} selected={workspaceAccessLevel == 2} >Locked, only for me and administrators</option>
                                </FoundationsSelect>
                                <div
                                    id="valmsg_list_dashboard_privacy_lock"
                                    className="field-validation-error"
                                ></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span
                id="edit_dashboard_loading"
                className={`ajax-loading-box popup-loading ${isLoading ? "" : "hide"}`}
            >
                <span className="ajax-loading-image">Saving...</span>
            </span>

        </Dialog>
    )
}

export default EditWorkspaceDialog